







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PageTitle } from '@questelservices/common-vue';
import FileParseUploads from '@/components/file-parse-uploads.vue';

@Component({
  components: {
    FileParseUploads,
    PageTitle
  }
})
export default class IncompleteUploads extends Vue {}
